/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1Checklist200,
  GetApiV1Checklist401,
  GetApiV1Checklist500,
  GetApiV1ChecklistQueryParams,
  GetApiV1ChecklistQueryResponse,
} from "../../types/checkListRegistroController/GetApiV1Checklist.ts";
import { checkListListItemViewModelPaginatedResponseSchema } from "../checkListListItemViewModelPaginatedResponseSchema.ts";

export const getApiV1ChecklistQueryParamsSchema = z.object({
  filter: z.optional(z.string()),
  active: z.optional(z.boolean()),
  page: z.coerce.number().int().default(1),
  pageSize: z.coerce.number().int().default(20),
}) as unknown as ToZod<GetApiV1ChecklistQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1Checklist200Schema = z.lazy(
  () => checkListListItemViewModelPaginatedResponseSchema,
) as unknown as ToZod<GetApiV1Checklist200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1Checklist401Schema =
  z.any() as unknown as ToZod<GetApiV1Checklist401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1Checklist500Schema =
  z.any() as unknown as ToZod<GetApiV1Checklist500>;

export const getApiV1ChecklistQueryResponseSchema = z.lazy(
  () => getApiV1Checklist200Schema,
) as unknown as ToZod<GetApiV1ChecklistQueryResponse>;
